import { Card, Colors, Icon } from '@blueprintjs/core'
import React from 'react'
import { UprightStyle } from '../types'
import Breadcrumbs from './Breadcrumbs'
import Spinner from './Spinner'

const styles: UprightStyle = {
  exportBtn: { display: 'flex', alignItems: 'center', marginBottom: '25px' },
  exportBtnContent: { marginBottom: 0, cursor: 'pointer', marginRight: 10 },
  errors: { marginBottom: '20px' },
  breadcrumbs: { marginBottom: 15 },
  widgetContainer: { marginBottom: 30 },
  widgetHeader: {
    marginBottom: 0,
    marginTop: 0,
    background: '#F5F8FA',
    padding: '12px',
    fontSize: '14px',
    borderBottom: 'rgba(16, 22, 26, 0.15) solid 1px',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px'
  },
  widgetContent: { padding: 15 }
}

const ExportButton = ({ onClickAction }) => {
  return (
    <div style={styles.exportBtn}>
      <p style={styles.exportBtnContent} onClick={onClickAction}>
        Export <Icon icon="download" color={Colors.GRAY2} />
      </p>
    </div>
  )
}

const Errors = props => {
  const { err } = props

  if (!err) return null
  const { errors, message } = err
  if (Object.keys(errors).length === 0 || !message) {
    return null
  }

  return (
    <div className="bp3-callout bp3-intent-danger" style={styles.errors}>
      <h5 className="bp3-callout-title bp3-heading"> {message}</h5>
      <ul>
        {Object.keys(errors).map(k => (
          <li>
            <strong>{k} </strong>
            {errors[k].join(', ')}
          </li>
        ))}
      </ul>
    </div>
  )
}

type Breadcrumb = { title?: any; to?: any }

interface Props {
  style?: any
  contentStyle?: any
  headerStyle?: any
  loading?: boolean
  err?: { message: string; errors: Record<string, string[]> }
  breadcrumbs?: Breadcrumb[]
  title?: React.ReactNode
  contentRef?: any
  exportAction?: () => void
  exportComponent?: React.ReactNode
}

const Widget: React.FC<Props> = ({
  style,
  loading = false,
  err = { message: '', errors: {} },
  breadcrumbs = [],
  title = '',
  children,
  contentStyle,
  contentRef,
  exportAction,
  exportComponent,
  headerStyle = {}
}) => (
  <>
    {breadcrumbs.length > 0 && <Breadcrumbs style={styles.breadcrumbs} paths={breadcrumbs} />}
    {exportAction && <ExportButton onClickAction={() => exportAction()} />}
    {exportComponent}
    <Card style={{ ...styles.widgetContainer, ...style, padding: 0 }}>
      <Errors err={err} />
      {title && (
        <h5
          className="widget-title"
          style={{
            ...styles.widgetHeader,
            ...headerStyle
          }}
        >
          {title}
        </h5>
      )}
      <div style={{ ...styles.widgetContent, ...contentStyle }} className="widget-content" ref={contentRef}>
        {loading ? <Spinner /> : children}
      </div>
    </Card>
  </>
)

export default Widget
